import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_ARROW_RIGHT: GlameraIconDefinition = {
  name: 'arrow-right',
  viewBox: '0 0 24 24',
  svg: `
    <g class="glm-arrow-right-nudge">
      <path d="M5 12h14"></path>
      <path d="m12 5 7 7-7 7"></path>
    </g>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-arrow-right-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './arrow-right.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class ArrowRightIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_ARROW_RIGHT;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
